"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WrapperChatListItem = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _templateObject;
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
var WrapperChatListItem = exports.WrapperChatListItem = _styledComponents["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: 100%;\n  padding: var(--spacing-3) var(--spacing-3) var(--spacing-3) var(--spacing-2);\n  cursor: pointer;\n  background-color: var(--color-neutral-70);\n\n  @media (min-width: 840px) {\n    &:hover {\n      background-color: var(--color-neutral-80);\n    }\n\n    &:hover .wrapper-status {\n      background-color: var(--color-neutral-100);\n    }\n  }\n\n  &:active {\n    background-color: var(--color-neutral-90);\n  }\n\n  ", "\n"])), function (_ref) {
  var isSelected = _ref.isSelected;
  return isSelected && "\n    background-color: var(--color-neutral-80);\n  ";
});